import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit, OnDestroy {
  isLoading = false;
  private subscription?: Subscription;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.subscription = this.loaderService.loading$.subscribe(
      (loading) => {
        this.isLoading = loading;
        // Bloquer/débloquer le scroll du body
        if (loading) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    );
  }

  ngOnDestroy() {
    // Restaurer le scroll si le composant est détruit
    document.body.style.overflow = '';
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

